// extracted by mini-css-extract-plugin
export default {"whyCard":"why-smarty-module--why-card--c0fa0","whyCardTitle":"why-smarty-module--why-card-title--7dfd5","darkText":"why-smarty-module--dark-text--13fcc"};